var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bcce336c-77f5-4b98-b14c-db08dd2446ee",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.09 68.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1.27,
    y: 1.27,
    width: 74.54,
    height: 52.09,
    rx: 3.78,
    style: {
      fill: "#fff",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.07,
    y1: 64.14,
    x2: 74.91,
    y2: 64.14,
    style: {
      fill: "none",
      stroke: "#4f5ca6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.34,
    cy: 64.14,
    r: 2.69,
    style: {
      fill: "#4f5ca6",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.54,
    cy: 27.77,
    r: 14.82,
    style: {
      fill: "none",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,414.13a.74.74,0,0,1,0,1.28L300,418.22l-4.85,2.8a.75.75,0,0,1-1.12-.65v-11.2a.75.75,0,0,1,1.12-.65l4.85,2.8Z",
    transform: "translate(-259.46 -386.45)",
    style: {
      fill: "#c54f70"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e964783f15fcec6a02e3a4e3a7dfd630.svg";
export { ForwardRef as ReactComponent };